import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import UnsavedChanges from '../notifications/UnsavedChanges';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { getRoutePathWithParams, navLinkSelectHandler, checkImpersonationActive, logErrorToConsole } from 'src/utils/util';
import {
    deleteAllSets,
    resetCreateReceiveSets,
    resetDetailsDropdownsReducer,
    resetReceiveSetsListDataReducer,
    resetSurgeryDetails,
    saveSetsOutsideTerritoryList,
    setBarcodeDetails,
    setProductDetails,
    setReceiveSetUnsavedChangesPopup,
    getDropdownValues,
    bulkEXcludedPopupData,
    resetBulkBarcodeDetailsData,
    createReceiveSetsFailure,
    resetBulkEXcludedPopupData,
} from '../../redux/actions';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import { useTranslation } from 'react-i18next';

function ReceiveSetsFooter({
    tabletPortraitMargin,
    justifyContent,
    zIndex = 2000,
    customStyle = {
        position: 'fixed',
        width: { standard: 'calc(100% - 5rem)', smallDevice: '100%' },
        padding: '5px',
        inPaddingVertical: '5px',
    },
    setIsSubmitClicked,
    setsList,
    submitBtnClickHandler,
    submitSuccess,
    setFieldFocus,
    setCounterMessage,
    setAccountValue,
    setTerritoryValue
}) {
    const { visualInspectionAcknowledgement } = useSelector((state) => ({
        visualInspectionAcknowledgement:
            state.surgeryReducer.visualInspectionAcknowledgement,
    }));

    const receiveSetUnsavedChangesPopup = useSelector(
        (state) =>
            state.receiveSetsListDataReducer.receiveSetUnsavedChangesPopup
    );
    const routePathForReceiveSetsUnsavedChangesPopUp = useSelector(
        (state) =>
            state.receiveSetsListDataReducer
                .routePathForReceiveSetsUnsavedChangesPopUp
    );
    const territoryObj = useSelector(
        (state) => state.receiveSetsListDataReducer.territory
    );
    const bulkExcludedData = useSelector(
        (state) => state.receiveSetsListDataReducer.bulkExcludedData
    );
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const [cancel, setCancel] = useState(false);

    const routePathForSSUnsavedChangesPopUp = useSelector(
        (state) => state.commonReducer.routePathForSSUnsavedChangesPopUp
    ); 
    let path = routePathForSSUnsavedChangesPopUp.path;

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const history = useHistory();

    useEffectWithErrorLogging(() => {}, [visualInspectionAcknowledgement]);

    const handleDiscardChanges = () => {
        setCounterMessage(0);
        let path = routePathForReceiveSetsUnsavedChangesPopUp.path;
        //setScheduleSurgeryCUInProgressLocal(false);
        navLinkSelectHandler(
            dispatch,
            setActiveNavLink,
            routePathForReceiveSetsUnsavedChangesPopUp.selectOption
        );
        dispatch(resetSurgeryDetails(''));
        dispatch(deleteAllSets([]));
        dispatch(setBarcodeDetails());
        dispatch(setProductDetails());
        dispatch(saveSetsOutsideTerritoryList([]));
        //setCancel(false);
        dispatch(createReceiveSetsFailure(false));
        dispatch(setReceiveSetUnsavedChangesPopup(false));
        dispatch(resetBulkBarcodeDetailsData([]));
        dispatch(resetBulkEXcludedPopupData([]));
        // dispatch(bulkEXcludedPopupData([]));
        if (path.includes('http')) {
            window.location.href = path;
        } else {
            history.push(getRoutePathWithParams(path));
        }
    };
    const handleBackToReceiveSetChanges = () => {
        setCounterMessage(0);
        dispatch(resetSurgeryDetails(''));
        dispatch(deleteAllSets([]));
        dispatch(setBarcodeDetails());
        dispatch(resetBulkBarcodeDetailsData([]));
        dispatch(setProductDetails());
        dispatch(saveSetsOutsideTerritoryList([]));
        dispatch(resetCreateReceiveSets());
        dispatch(resetReceiveSetsListDataReducer());
        dispatch(resetDetailsDropdownsReducer());
    };
    const backToReceiveSetsClickHandler = () => {
        setCounterMessage(0);
        setIsSubmitClicked(false);
        handleBackToReceiveSetChanges();
        dispatch(getDropdownValues({ dropDownName: 'territories' }));
        dispatch(resetBulkBarcodeDetailsData([]));
        if (bulkExcludedData) {
            dispatch(resetBulkEXcludedPopupData([]));
        }
    };
    const handleDiscardNavigationChanges = () => {
        setCounterMessage(0);
        setCancel(false);
        dispatch(resetSurgeryDetails(''));
        dispatch(deleteAllSets([]));
        dispatch(setBarcodeDetails());
        dispatch(resetBulkBarcodeDetailsData([]));
        dispatch(setProductDetails());
        dispatch(saveSetsOutsideTerritoryList([]));
        dispatch(resetReceiveSetsListDataReducer());
        dispatch(resetDetailsDropdownsReducer());
        dispatch(getDropdownValues({ dropDownName: 'territories' }));
        if (!checkImpersonationActive()){
            navLinkSelectHandler(
                dispatch,
                setActiveNavLink,
                routePathForSSUnsavedChangesPopUp.selectOption
            );
            if (path.includes('http')) {
                window.location.href = path;
        } else {
            if (!path || path == '') {
                history.goBack();
            }
            else {
                history.push(getRoutePathWithParams(path));
            }
        }
    }};
    return (
        <>
            <BottomNavigation
                justifyContent="space-around"
                moblieJustifyContent="space-evenly"
                padding={customStyle.padding}
                right={'0'}
                position={customStyle.position}
                width={customStyle.width}
                zIndex={zIndex}
            >
                <BottomNavigationButtonContainer
                    smallJustifyContent={'center'}
                    justifyContent={justifyContent}
                    tabletPortraitMargin={tabletPortraitMargin}
                >
                    {!submitSuccess && (
                        <>
                            <Button
                            id={'recieveSets-receive-sets-footer-cancel-button'}
                                show={true}
                                width={isLanguageChanged ? 'fit-content':'102px'}
                                mobileWidth={'155px'}
                                height={'38px'}
                                margin={'5px'}
                                // fontSize={'15px'}
                                //cancel={true}
                                variant={ButtonStyles?.cancel}
                                clicked={() => {
                                    try {
                                    setCancel(true);
                                    setAccountValue('');
                                    setTerritoryValue('');
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                    }}
                            >
                                {t('reportUsage.common.cancel')}
                            </Button>
                            <Button
                            id={'recieveSets-receive-sets-footer-submit-button'}
                                show={true}
                                // primary={
                                //     setsList &&
                                //     setsList.length > 0 &&
                                //     territoryObj !== '' &&
                                //     !setFieldFocus
                                //         ? true
                                //         : false
                                // }
                                width={'102px'}
                                mobileWidth={'155px'}
                                height={'38px'}
                                margin={'5px'}
                                // fontSize={'15px'}
                                clicked={() => {
                                    try {
                                    //  setIsSubmitClicked(true);
                                    submitBtnClickHandler();
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                                disabled={
                                    setsList &&
                                    setsList.length > 0 &&
                                    territoryObj !== '' &&
                                    !setFieldFocus
                                        ? false
                                        : true
                                }
                                variant={setsList && setsList.length > 0 && territoryObj !== '' ? ButtonStyles?.primary : ButtonStyles?.disabled}
                            >
                                {t('consignment.progressBar.submit')}
                            </Button>
                        </>
                    )}
                    {submitSuccess && (
                        <Button
                        id="receivesets-footer-back-to-receive-sets-button"
                            show={true}
                            //secondary={true}
                            variant={ButtonStyles?.secondary}
                            width={'170px'}
                            mobileWidth={'170px'}
                            height={'38px'}
                            margin={'5px'}
                            // fontSize={'15px'}
                            clicked={backToReceiveSetsClickHandler}
                            WhiteSpace={'nowrap'}
                            // disabled={setsList && setsList.length > 0 ? false : true}
                        >
                            {t(
                                'receiveSets.ReceiveSetsLoc.AddSetsLists.backToReceiveSets'
                            )}
                        </Button>
                    )}
                </BottomNavigationButtonContainer>
            </BottomNavigation>
            {receiveSetUnsavedChangesPopup ? (
                <UnsavedChanges
                id="receivesets-footer-unsavedchanges-popup"
                    onDiscard={() => handleDiscardChanges()}
                    onClose={() =>
                        dispatch(setReceiveSetUnsavedChangesPopup(false))
                    }
                />
            ) : null}
            {cancel ? (
                <UnsavedChanges
                id="receivesets-footer-cancel-popup"
                    onDiscard={() => handleDiscardNavigationChanges()}
                    onClose={() => setCancel(false)}
                />
            ) : null}
        </>
    );
}

export default ReceiveSetsFooter;

const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
        margin-right: 45px;
    }

    @media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
        /* For ipad landscape layouts only */
        margin-right: 45px;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'center'};
        margin: ${(props) =>
            props.tabletPortraitMargin ? props.tabletPortraitMargin : ''};
    }

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        margin-right: 20px;
    }

    ${media.mobileDevice`
        justify-content: space-evenly;
    `}
`;
